module.exports = __webpack_public_path__ + "img/20200226135204360截图20200226134216142.affedd49.jpg";